import React from 'react'
import FlipMove from 'react-flip-move'
import { useStateValue } from '../../../contextAPI/StateProvider'

import './CheckoutProduct.css'

const CheckoutProduct = ({ id, image, title, price, rating }) => {
	const [{ basket }, dispatch] = useStateValue()

	const removeFromBasket = () => {
		// remove the item from the basket
		dispatch({
			type: 'REMOVE_FROM_BASKET',
			id: id
		})
	}

	return (
		<FlipMove>
			<div className='checkoutProduct'>
				<img className='checkoutProduct__image' src={image} alt={id} />

				<div className='checkoutProduct__info'>
					<p className='checkoutProduct__title'>{title}</p>
					<p className='checkoutProduct__price'>
						<small>&#36;</small>
						<strong>{price}</strong>
					</p>
					<div className='checkoutProduct__rating'>
						{Array(rating)
							.fill()
							.map((_, i) => (
								<p key={i}>&#9733;</p>
							))}
					</div>
					<button onClick={removeFromBasket}>Remove from Basket</button>
				</div>
			</div>
		</FlipMove>
	)
}

export default CheckoutProduct
